import * as React from 'react';
import { FormikErrors } from 'formik';
import { isObject, get, set } from 'lodash';
import scrollToComponent from 'react-scroll-to-component';

export interface Props {
    // tslint:disable-next-line:no-any
    errors: FormikErrors<any>;
    isSubmitting: boolean;
    isValid: boolean;
    render: (args: RenderProps) => JSX.Element | null;
}

// tslint:disable-next-line:no-any
type RenderProps = { setFieldRef: (field: string, node: any) => void };
export class ScrollToError extends React.PureComponent<Props> {

    formRefs = {};

    componentDidUpdate(previousProps: Props) {
        // if form was submitting, but now is not submitting because it is invalid
        if (previousProps.isSubmitting && !this.props.isSubmitting && !this.props.isValid) {
            const firstError = this.getFirstErrorPath();
            const firstErrorRef = get(this.formRefs, firstError);
            this.scrollToField(firstErrorRef);
        }
    }

    /**
     * Get the first error accounting for nested object schemas
     */
    getFirstErrorPath() {
        const { errors } = this.props;
        let path = [];
        // tslint:disable-next-line:no-any
        let values: any = errors;
        while (isObject(values)) {
            const errorLevelKey = Object.keys(values)[0];
            const errorLevelValue = values[errorLevelKey];
            path.push(errorLevelKey);
            values = errorLevelValue;
        }
        return path;
    }

    scrollToField(field: JSX.Element | null) {
        scrollToComponent(field, { align: 'top', offset: -100 });
    }

    // tslint:disable-next-line:no-any
    setFieldRef = (field: string, node: any) => {
        set(this.formRefs, field, node);
    }

    render() {
        return (
            this.props.render({ setFieldRef: this.setFieldRef })
        );
    }
}